Backbone = require 'backbone'
Backbone.$ = $
SupportMultipleQuantityPopupTemplate = require('../../multiple_quantity_popup.html.mustache')

class SupportMultipleQtyPopupView extends Backbone.View

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportMultipleQuantityPopupTemplate
    @validate(@options)
    @orderWithMultipleQty = {}
    @orderWithMultipleQty.userPermalink = currentUser.id
    @orderWithMultipleQty.vouchers = @options.orders
    @parent = $('#popup')
    @orderWithMultipleQty.title = @options.title
    @orderWithMultipleQty.singleActionButtonCallback = @options.singleActionButtonCallback
    @orderWithMultipleQty.groupActionButtonCallback = @options.groupActionButtonCallback
    @orderWithMultipleQty.singleActionButtonName = @options.singleActionButtonName
    @orderWithMultipleQty.groupActionButtonName = @options.groupActionButtonName
    @orderWithMultipleQty.showgroupActionButton =  @options.showgroupActionButton
    @orderWithMultipleQty[@options.serviceActionName] = true

    @orderWithMultipleQty.showAlertMessage = @options.showAlertMessage
    @orderWithMultipleQty.alertMessage = @options.alertMessage

    # for Mustache manipulation
    @orderWithMultipleQty.vouchers.expiredDate = @options.orders.groupons[0].expiresAtFormattedStr
    if !!@orderWithMultipleQty.vouchers.expiredDate
        @orderWithMultipleQty.vouchers.validExpirationDate = true
    else
        @orderWithMultipleQty.vouchers.validExpirationDate = false
    @orderWithMultipleQty.vouchers.purchasedDate  = @options.orders.purchasedAtshortDatetimeStr
    @orderWithMultipleQty.vouchers.orderId = @options.orders.id
    @avaliableVoucherCount = 0
    for groupon, i in @orderWithMultipleQty.vouchers.groupons
        groupon.index = i + 1
        groupon.dealOptionTitle = @options.orders.dealOption.title
        if groupon?.availability? && groupon.availability is 'refunded'
          groupon.isRefunded = true
        else if groupon.customerRedeemedAt || groupon.merchantRedeemedAt
          groupon.isRedeemed = true
        else
          groupon.showSingleActionButton = true
          @avaliableVoucherCount++
        groupon.dealPermalink = @options.orders.deal.id
        groupon.url = @orderWithMultipleQty.singleActionButtonCallback groupon
    BHData = window.getOrderInfoForBH(@orderWithMultipleQty.vouchers)
    BHData.orderId = BHData.id
    delete BHData['id']
    _.extend @orderWithMultipleQty, BHData
    if window.isUS() and @avaliableVoucherCount >= @orderWithMultipleQty.vouchers.groupons.length and @orderWithMultipleQty.showgroupActionButton
      @orderWithMultipleQty.urlForVouchers = @orderWithMultipleQty.groupActionButtonCallback @orderWithMultipleQty.vouchers.orderId
    else
       @orderWithMultipleQty.urlForVouchers =  false
    @orderWithMultipleQty.showViewOrderDetailsLink = window.showViewOrderDetailsLink

  validate: (options)->
    throw new Error("singleActionButtonName Property should be defined") if @options.singleActionButtonName == null
    throw new Error("singleActionButtonCallback Property should be defined") if @options.singleActionButtonCallback == null
    throw new Error("showgroupActionButton Property should be defined") if @options.showgroupActionButton == null
    if @options.showgroupActionButton is true
      throw new Error("groupActionButtonName Property should be defined") if @options.groupActionButtonName == null
      throw new Error("groupActionButtonCallback Property should be defined") if @options.groupActionButtonCallback == null
    if @options.showAlertMessage  is true
      throw new Error("alertMessage Property should be defined") if @options.alertMessage == null

  render: ->
    @renderMultipleGroupons()
    GIG.Modal.open
      el: @parent
      closeOnBgClick: true
      closeOnEscKey: true
    @parent.html @$el

  renderMultipleGroupons: ->
    @$el.html toHtml(@template, @orderWithMultipleQty, @I18nScope)

  viewOrderDetails: (ev)->
    userPermalink = currentUser.id
    orderId = Groupon.Support.currentOrder.id
    url = "/users/#{userPermalink}/orders/#{orderId}"
    window.open(url)

  closeModal: ->
    GIG.Modal.close()
    return false

  events :
    "click #viewOrderDtls"     : "viewOrderDetails"
    "click .close-modal"       : "closeModal"

module.exports = SupportMultipleQtyPopupView
